"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formToPayloadDataHandler_1 = require("./formToPayloadDataHandler");
const initialData_1 = __importDefault(require("./initialData"));
const onHandleChange_1 = require("./onHandleChange");
const payloadToFormDataHandler_1 = require("./payloadToFormDataHandler");
const schema_1 = __importDefault(require("./schema"));
const uiSchema_1 = __importDefault(require("./uiSchema"));
const scheduleSocTemplate = {
    schema: schema_1.default,
    uiSchema: uiSchema_1.default,
    initialData: initialData_1.default,
    formToPayloadDataHandler: formToPayloadDataHandler_1.scheduleSocFormToPayloadDataHandler,
    payloadToFormDataHandler: payloadToFormDataHandler_1.scheduleSocPayloadToFormDataHandler,
    onHandleChange: onHandleChange_1.onHandleChange,
    onHandleChangeDependencies: onHandleChange_1.onHandleChangeDependencies,
};
exports.default = scheduleSocTemplate;
